import axios from 'axios'
import { portalLoginPath } from '@/utils/portal-login-path'

const SHELL_HOSTED = process.env.REACT_APP_SHELL_HOSTED === 'true'

// True once a 401 has started sending the user to login, so later 401s stay quiet.
let redirectingAfter401 = false

function handleResponse(response) {
	if (response.hasOwnProperty("data")) {
		if (response.data.hasOwnProperty("data")) {
			return [undefined, response.data.data]
		}
		return [undefined, response.data]
	}

	if (response.hasOwnProperty("results")) {
		return [undefined, response.results]
	}
	return [undefined, response]
}

function handleError(error) {
	const status = error?.response?.status

	if (error && status === 401) {
		// sessionStorage.clear()
		// delete axios.defaults.headers.common['Authorization']
		// window.location.assign('/login')
		if (SHELL_HOSTED && !redirectingAfter401) {
			// Read the dex before the wipe destroys it. Only the FIRST 401 redirects;
			// the rest do nothing — if we let them run, they would see the dex already
			// wiped and send the user to /login instead.
			redirectingAfter401 = true
			const target = portalLoginPath()
			sessionStorage.clear()
			delete axios.defaults.headers.common['Authorization']
			window.location.assign(target)
		}
	}

	if (status === 404) {
		return ["Your account has limited access rights. Please contact your administrator for assistance.", undefined]
	}
	if (error?.response?.data?.error) {
		return [error.response.data.error, undefined]
	}
	if (error?.response?.data?.data?.error) {
		return [error.response.data.data.error, undefined]
	}
	else {
		return [error, undefined]
	}
}

function handleErrorWithoutRedirect (error){
	if (error?.response?.data?.error) {
		return [error.response.data.error, undefined]
	}
	else {
		return [error, undefined]
	}
}

export { handleResponse, handleError, handleErrorWithoutRedirect }
